<template>
  <div id="StudyPublication" class="study">
    <div class="container-fluid head" style="background-color: #2D1E55">
      <Header />

      <h1>Publication</h1>
    </div>

    <div class="container">

      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 1.webp" width="90%" class="mb-5" />
        </div>
        <div class="col-12 col-md-6">
          <h2>The Project</h2>
          <p>
            The goal of this project is to create a dust jacket with a front, back, spine, and inside flaps, as well as a cover with a few simple elements on the front and spine.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>The Project</h2>
          <p>
            Create a two-page spread magazine article in InDesign/Illustrator, presenting a designer from a major movement or school. Using original images (Photoshop, Illustrator, or hand- drawn & digitized) and fonts appropriate to that style. Incorporate the Q&A and a photo (or drawing) of the designer.<br /><br />
            Must contain:<br /><br />
          <ul>
            <li>The designer's name</li>
            <li>A portrait (photography or illustration) of the designer</li>
            <li>Q&A</li>
            <li>Some of his/her artworks</li>
          </ul>
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <img src="/images/Publication/Publication 2.webp" width="100%" />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2>The Project</h2>
          <p>
            To create a Brand Style Guidelines to explain anyone how to use your brand design and identity design including:<br/><br/>
          <ul>
            <li>A short (1-2 paragraphs) overview of your brand's vision/ personality and key values</li>
            <li>Logo usage and color variations (if applicable)</li>
            <li>Color pallet(s) and system </li>
            <li>Typography system </li>
            <li>Imagery style and system </li>
            <li>Brand application rules and grid system (Print and/or Web) </li>
            <li>Do's and Don'ts </li>
          </ul>
          </p>
        </div>
      </div>


      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 3.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 3-1.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 4.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 5.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 6.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 7.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 8.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 9.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 10.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 11.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 12.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 13.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 14.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 15.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 16.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 17.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 18.webp" width="100%" />
        </div>
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 19.webp" width="100%" /><br /><br />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <img src="/images/Publication/Publication 20.webp" width="100%" />
        </div>
      </div>

    </div>
    <Footer />

  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyPublication",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () { },
};
</script>

<style lang="scss">
#StudyPublication {
  h2 {
    color: #46478A;
  }
}
</style>